<template>
  <div class="full-height" :class="isEcomV2 ? 'smaller-container-wrapper' : 'mt-4 '">
    <div class="mb-4">
      <CarfaxLogoContainer class="mb-2" />
      <h2 class="font-weight-bold mt-4 fs-5 fs-md-4 fs-lg-3">{{ carfaxTradeInTitle }}</h2>
      <p class="carfax-msg mt-3" v-if="!isEcomV2">
        {{ $t('message.trade.carFaxVehicleBasicDetailsMsg') }}
      </p>
    </div>
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <YearMakeModelSelector />

      <div class="push-down-desktop">
        <mobialis-button type="submit" class="next-btn mt-5 mb-3" data-cy="continue">
          {{ $t('message.common.continue') }}
        </mobialis-button>
        <mobialis-button
          v-if="currentSubFlow !== 'trade-in' && isEcomV2"
          variant="link"
          @click="skipTrade"
          data-cy="skipTrade"
          v-av-analytics-cta-interaction="{
            elementText: $t('message.eCommerceV2.tradeInFlow.skipTrade'),
            eventActionResult: 'open',
          }"
        >
          {{ $t('message.eCommerceV2.tradeInFlow.skipTrade') }}
        </mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import CarfaxLogoContainer from '@/components/shared/trade-in-carfax/CarfaxLogoContainer.vue';
import YearMakeModelSelector from '@/components/shared/trade-in-carfax/YearMakeModelSelector.vue';
import { AVRProducts } from '@/utils/enums';

export default {
  name: 'CarfaxBasicForm',
  components: { CarfaxLogoContainer, YearMakeModelSelector },
  computed: {
    isEcomV2() {
      return this.$store.getters.getCurrentProduct === AVRProducts.ECOMV2;
    },
    isAcquire() {
      return this.$store.getters.getCurrentProduct === AVRProducts.ACQUIRE;
    },
    carfaxTradeInTitle() {
      return this.isEcomV2
        ? this.$t('message.eCommerceV2.tradeInFlow.autoComplete.heading')
        : this.$t('message.trade.carFaxTradeInTitle');
    },
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        return;
      }
      // eslint-disable-next-line no-unused-expressions
      this.isAcquire
        ? this.$store.commit('trade/SET_LEAD_ACQUIRE_VEHICLE')
        : this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
      const year = encodeURIComponent(this.$store.state.trade.vehicle.year);
      const make = encodeURIComponent(this.$store.state.trade.vehicle.make);
      const model = encodeURIComponent(this.$store.state.trade.vehicle.model);
      const url = this.isEcomV2 ? 'carfax-details-form' : `${year}/${make}/${model}/carfax-details-form`;
      this.$router.push({ path: url });
    },
    skipTrade() {
      // only visible the personalized payments main flow and make an offer flow
      // reset state related to trade in
      this.$store.commit('trade/RESET_VEHICLE');
      this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
      this.$store.commit('paymentCalculator/REMOVE_TRADE');
      if (this.ecomFlowSelected === 'personalized-payment') {
        this.$router.push({ path: 'contact-info-form' });
      } else {
        this.$router.push({ path: 'payment-calculator' });
      }
    },
  },
};
</script>
